import { render, staticRenderFns } from "./goodsClassifyDialog.vue?vue&type=template&id=3af568d0"
import script from "./goodsClassifyDialog.vue?vue&type=script&lang=js"
export * from "./goodsClassifyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports